import { axiosInstance } from '../axios';
import { apiReason as reason } from '../constants/consts';

const postApi = {
  signIn(data) {
    const realm = data?.realm || 'nexway';
    const url = `/iam/tokens?reason=${reason}`;
    const grantType = data?.grantType || 'password';

    return axiosInstance({
      method: 'post',
      url,
      data: {
        ...data,
        realm,
        grantType,
      },
    });
  },
  signInTwoFa(data) {
    const realm = data?.realm || 'nexway';
    const url = '/iam/tokens/2fa';

    return axiosInstance({
      method: 'post',
      url,
      data: {
        ...data,
        realm,
      },
    });
  },
  signInWithBackupCode(data) {
    const realm = data?.realm || 'nexway';
    const url = '/iam/2fa/public/recovery';

    return axiosInstance({
      method: 'post',
      url,
      data: {
        ...data,
        realm,
      },
    });
  },
  recoverPassword(data, realm = 'nexway') {
    return axiosInstance({
      method: 'post',
      url: `/iam/identities/lostpassword/${realm}`,
      data,
    });
  },
  setNewPassword(customer, token, data) {
    const url = `/iam/identities/resetpassword/${customer}/${token}?reason=${reason}`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewTheme(data) {
    const url = `designs/themes?reason=${reason}`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewMetaRole(data) {
    const url = `/iam/meta-roles?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewRole(data) {
    const url = `/iam/roles?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewFont(data) {
    const url = `designs/fonts?reason=${reason}`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewTranslation(data) {
    const url = '/designs/i18ns';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewLayout(data) {
    const url = '/designs/layouts';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewMarkup(data) {
    const url = '/designs/markup';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewProduct(data) {
    const url = `/products?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewPrice(data) {
    const url = `/prices?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewAsset(file) {
    const url = '/assets';
    const data = new FormData();
    data.append('file', file);

    return axiosInstance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    });
  },
  addNewDiscount(data) {
    const url = `/discounts?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewRecommendation(data) {
    const url = `/product-recommendations?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  sendConfirmationMail(customerId, data) {
    const url = `/ordersv2/${customerId}/email/send?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  sendConfirmationMailforMarketplaceOrder(orderId, data) {
    const url = `/marketplaces-orders/${orderId}/email/send?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  sendConfirmationMailOnboarding(onboardingId, data) {
    const url = `/onboarding/${onboardingId}/email/send?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  sendConfirmationMailOnboardScreen(capchaToken, data) {
    const url = `/onboarding/public?capchaToken=${capchaToken}&reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  resyncPayments(orderId) {
    const url = `/payment-proxy/payments/${orderId}/resync?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  resyncEndUser(orderId) {
    const url = `/ordersv2/${orderId}/resync-enduser?reason=${reason}%20POST`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  cancelOrder(customerId, dbVersion, reason) {
    const url = `/ordersv2/${customerId}/fullcancel?dbVersion=${dbVersion}&cancellationReason=${reason}&reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },

  addNewIdentity(data) {
    const url = `/iam/identities?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNewSecretKeyToIdentity(id) {
    const url = `/iam/identities/${id}/secret?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  addNewStore(data) {
    const url = `/stores?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addSubsidiary(data) {
    const url = `/subsidiary-manager/subsidiaries?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addCustomerById(data) {
    const url = `/customers?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addCurrency(data) {
    const url = '/referential-manager/currency';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addLocale(data) {
    const url = '/referential-manager/locale';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addCountry(data) {
    const url = '/referential-manager/country';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },

  addRegion(data) {
    const url = '/referential-manager/region';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },

  addCatalogs(data) {
    const url = `/catalogs?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addCustomFieldDefinitions(data) {
    const url = `/products/customFieldsDefinition?reason=${reason}[POST]`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNotification(data) {
    const url = `/notification/receivers?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addNotificationDefinition(data) {
    const url = `/notification/definitions/?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addLicenseProviderDefinition(data) {
    const url = `/license-manager/license-provider-definitions?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addAbandonedCart(data) {
    const url = `/campaigns/abandonedcarts?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addLicenseExpirationCampaign(data) {
    const url = `campaigns/license-expiration-campaigns?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  sendByEmailByCartId(id) {
    const url = `/carts/public/${id}/sendByMail?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },

  retrySendingByNotificationId(id) {
    const url = `/customer-notifier/retryNotification/${id}?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },

  generateCodes(id, data) {
    const url = `/discounts/${id}/generate?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addCart(data) {
    const url = `carts?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addEndUserGroup(data) {
    const url = `/endusers/groups?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  emailTestTemplating(data) {
    const url = `/email-builder/operations/testTemplating?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  cloneEmailTemplate(data) {
    const url = `/email-builder/template-definitions/clone?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addPriceFunction(data) {
    const url = `/products/price-functions?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addInvoiceTranslation(data) {
    const url = `/designs/legali18ns?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  repairOrder(id, dbVersion) {
    const url = `/ordersv2/${id}/repair?dbVersion=${dbVersion}&reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  updateSubscriptions(id, newStatus) {
    const url = `/subscription-manager/subscriptions/${id}/${newStatus}?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  addManualFulfillment(data) {
    const url = `/license-keys-provider/packages?reason=${reason}%20POST%20%3A%20reason%20not%20specified`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addBatchesToManualFulfillmentById(id, data) {
    const url = `/license-keys-provider/import/${id}`;

    return axiosInstance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    });
  },
  addLicenseKeysToManualFulfillmentById(data) {
    const url = `/license-keys-provider/packages/${data.packageId}/batch`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  addProductLocalsById(data) {
    const url = '/products/descriptions';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  duplicateProductById(id, data) {
    const url = `/products/duplicate/${id}`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  generateSecretKey() {
    const url = '/iam/2fa/generate-secret-key';

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  verifyCode(code) {
    const url = `/iam/2fa/verify-2fa-code/${code}`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  checkCSVFile(customer, file) {
    const url = `/import-export-manager/import/price?separator=;&customerId=${customer}`;
    const data = new FormData();
    data.append('file', file);

    return axiosInstance({
      method: 'post',
      url,
      data,
      headers: {
        'Content-type': 'multipart/form-data',
      },
    });
  },
  createSubscriptionRenewalOffer(data) {
    const url = '/carts/subscription-offers';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  createPrebillingOrder(data) {
    const url = '/purchases/prepareNextOrderFromOffer';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  createCustomField(data) {
    const url = '/products/customFields';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  createPriceBeautifierRules(data) {
    const url = '/discounts/priceBeautifierConfig';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  launchSubscriptionPreBilling(subscriptionId) {
    const url = `/subscription-engine/api/subscriptions/${subscriptionId}/pre-billing?force=true`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  launchSubscriptionChargeAttempt(subscriptionId) {
    const url = `/subscription-engine/api/subscriptions/${subscriptionId}/charge`;

    return axiosInstance({
      method: 'post',
      url,
    });
  },
  addTnc(data) {
    const url = '/tandcs/templates';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },

  partialRefund(orderId, data) {
    const url = `ordersv2/${orderId}/partial-refund`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  exportInvoiceByFilter(data) {
    const url = `/invoices/invoice-jobs`;

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  createGoogleSession(data) {
    const url = 'iam/SSO/google/createSession';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
  connectGoogle(data) {
    const url = 'iam/SSO/google/connect';

    return axiosInstance({
      method: 'post',
      url,
      data,
    });
  },
};

export default postApi;
